import Vue from 'vue';

/** Franchise Snapshot Vue Element*/
Vue.component('vuetable_snapshot', () =>
    import(/* webpackChunkName: 'snapshot' */ './vuetable_snapshot.vue'),
);

Vue.component('vue_snapshot', () =>
    import(/* webpackChunkName: 'snapshot' */ './vue_snapshot.vue'),
);
